import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martina S.',
  role: 'Volante Central, 22 años',
  text: 'Siempre sentí que corría de más y llegaba tarde a todas. Con el capítulo de inteligencia táctica entendí cómo posicionarme. Ahora juego mucho más tranquila y rindo el doble.'
}, {
  name: 'Lucía G.',
  role: 'Defensora, 25 años',
  text: 'El módulo de mentalidad me cambió la cabeza. Antes me equivocaba en un pase y me caía anímicamente todo el partido. Hoy juego con una confianza que no sabía que tenía.'
}, {
  name: 'Camila R.',
  role: 'Extremo, 19 años',
  text: 'Entreno 4 veces por semana pero me faltaba entender el juego. Este manual es oro puro. Las explicaciones de los perfiles y controles orientados me hicieron ganar segundos clave.'
}, {
  name: 'Sofía M.',
  role: 'Delantera, 24 años',
  text: 'La parte de decisiones bajo presión es increíble. Dejé de sacarme la pelota de encima por miedo a perderla. Ahora levanto la cabeza y decido mejor. Súper recomendado.'
}, {
  name: 'Valentina P.',
  role: 'Lateral, 21 años',
  text: 'Lo que más me sirvió fue entender mi rol en el sistema. A veces subía a destiempo y dejaba el hueco. Ahora sé exactamente cuándo pasar al ataque y cuándo quedarme.'
}];
export function Testimonials() {
  return <section className="py-20 bg-brand-dark px-4 relative overflow-hidden" data-id="element-137">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-138">
        <h2 className="text-3xl md:text-5xl font-black text-center uppercase tracking-tight mb-16" data-id="element-139">
          Jugadoras que ya{' '}
          <span className="text-brand-pink" data-id="element-140">cambiaron su juego</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-141">
          {testimonials.map((t, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-8 rounded-2xl relative group hover:border-brand-pink/50 transition-colors" data-id="element-142">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-zinc-800 group-hover:text-brand-pink/20 transition-colors" data-id="element-143" />
              <div className="flex gap-1 mb-4" data-id="element-144">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-brand-pink text-brand-pink" data-id="element-145" />)}
              </div>
              <p className="text-zinc-300 mb-6 text-lg italic relative z-10" data-id="element-146">
                "{t.text}"
              </p>
              <div data-id="element-147">
                <p className="font-bold text-white text-lg" data-id="element-148">{t.name}</p>
                <p className="text-brand-pink text-sm font-medium" data-id="element-149">{t.role}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-24 text-center max-w-5xl mx-auto px-4" data-id="element-150">
          <h3 className="text-3xl md:text-5xl lg:text-6xl font-black uppercase leading-[1.1] text-white whitespace-nowrap" data-id="element-151">
            <span className="block md:inline" data-id="element-152">"No entrenes más…</span>{' '}
            <span className="block md:inline" data-id="element-153">
              entrená <span className="text-brand-pink" data-id="element-154">mejor</span>."
            </span>
          </h3>
        </div>
      </div>
    </section>;
}